<template>
	<div class="app-sidebar-company-reference-materials">
		<div class="category-title ao-p1-medium ao-text-secondary-color mb-4 px-6">{{ $t('menu.directories') }}</div>
		<div
			v-for="category in filteredLinksByCategory"
			:key="`sidebar-category-${category.key}`"
			class="category-list mb-11 px-5"
		>
			<div class="category-title ao-p2-medium ao-text-secondary-color mb-4 px-2">
				{{ category.title }}
			</div>

			<div
				v-for="link in category.links"
				:key="`category-link-${link.name}`"
				class="category-link"
			>
				<SidebarLink
					:to="{
						name: link.meta.defaultChild || link.name,
						params: { companyId: selectedCompanyId },
					}"
					:title="link.meta.titleTranslationKey ? $t(link.meta.titleTranslationKey) : link.meta.title"
					:loadedRouterLink="loadedRouterLink"
					:active="route.name === link.name"
					@click="$emit('click:link')"
				/>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'

import useRouts from '@/composables/useRouts'
import useNavigation from '@/composables/useNavigation'

import SidebarLink from './SidebarLink.vue'

import { useUserStore } from '@/stores/userStore'
import { useCompanyStore } from '@/stores/companyStore'

import eventBus from '@/plugins/eventBus'

import { COMPANY_REFERENCE_MATERIALS_PAGES } from '@/config/router/companyReferenceMaterialsPagesConfig'

defineEmits({
	'click:link': null,
})

const { t: $t } = useI18n()

const {
	route,
} = useRouts()

const userStore = useUserStore()
const { selectedCompanyId } = storeToRefs(userStore)

const companyStore = useCompanyStore()
const {
	availableRouteReferenceMaterialsByCompanyLicense,
} = storeToRefs(companyStore)

const {
	referenceGroups,
} = useNavigation()

const filteredLinksByCategory = computed(() => {
	let categories = []

	for (const categoryKey in referenceGroups.value) {
		if (Object.hasOwnProperty.call(referenceGroups.value, categoryKey)) {
			const category = Object.assign({}, referenceGroups.value[categoryKey])

			category.links = COMPANY_REFERENCE_MATERIALS_PAGES
				.filter((route) => (route.meta.categoryKey === category.value))
				.filter((route) => availableRouteReferenceMaterialsByCompanyLicense.value.includes(route.name))

			if (category.links.length > 0) {
				categories.push(category)
			}
		}
	}

	return categories
})

const loadedRouterLink = ref(null)
const updateRouterLinkState = (payload) => {
	if (payload.status === 'start') {
		loadedRouterLink.value = payload.name
	} else {
		loadedRouterLink.value = null
	}
}

onMounted(() => {
	eventBus.$on(eventBus.eventNames.getNavigationRouterLinkLoading(), updateRouterLinkState)
})

onBeforeUnmount(() => {
	eventBus.$off(eventBus.eventNames.getNavigationRouterLinkLoading())
})
</script>
